import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { NotificationsActions } from './actions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { constants } from 'src/app/core/constants/constants';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';
import { DocGenerationSnackbarComponent } from '../components/doc-generation-snackbar/doc-generation-snackbar.component';
import { WorkspaceCreationSnackbarComponent } from '../components/workspace-creation-snackbar/workspace-creation-snackbar.component';
import { WorkspaceAddDocsSnackbarComponent } from '../components/workspace-add-docs-snackbar/workspace-add-docs-snackbar.component';

@Injectable()
export class NotificationFeatureEffects {
  showNotification$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NotificationsActions.showNotification),
        tap(({ config, message, action }) => {
          this.snackBar.open(message, action, {
            duration: constants.notificationHideDelay,
            horizontalPosition: 'left',
            verticalPosition: 'bottom',
          });
        }),
      ),
    { dispatch: false },
  );

  showNotificationComponent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NotificationsActions.showNotificationComponent),
        tap(({ message, icon, title, duration }) => {
          let durationValue;

          if (!duration) {
            durationValue = constants.notificationHideDelay;
          } else {
            durationValue =
              duration === constants.notificationInfinityHideDelayKeyValue ? undefined : duration; // undefined = infinity
          }

          this.snackBar.openFromComponent(SnackbarComponent, {
            data: {
              message,
              icon,
              title,
            },
            duration: durationValue,
            horizontalPosition: 'left',
            verticalPosition: 'bottom',
          });
        }),
      ),
    { dispatch: false },
  );

  showDocGenerationNotificationComponent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NotificationsActions.showDocGenerationNotificationComponent),
        tap(({ icon, title, duration, docName, uniqueId }) => {
          let durationValue;

          if (!duration) {
            durationValue = constants.notificationHideDelay;
          } else {
            durationValue =
              duration === constants.notificationInfinityHideDelayKeyValue ? undefined : duration; // undefined = infinity
          }

          this.snackBar.openFromComponent(DocGenerationSnackbarComponent, {
            data: {
              icon,
              title,
              docName,
              uniqueId,
            },
            duration: durationValue,
            horizontalPosition: 'left',
            verticalPosition: 'bottom',
          });
        }),
      ),
    { dispatch: false },
  );

  showWorkspaceCreationNotificationComponent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NotificationsActions.showWorkspaceCreationNotificationComponent),
        tap(({ icon, title, duration, uniqueId }) => {
          let durationValue;

          if (!duration) {
            durationValue = constants.notificationHideDelay;
          } else {
            durationValue =
              duration === constants.notificationInfinityHideDelayKeyValue ? undefined : duration; // undefined = infinity
          }

          this.snackBar.openFromComponent(WorkspaceCreationSnackbarComponent, {
            data: {
              icon,
              title,
              uniqueId,
            },
            duration: durationValue,
            horizontalPosition: 'left',
            verticalPosition: 'bottom',
          });
        }),
      ),
    { dispatch: false },
  );

  showWorkspaceAddDocumentsNotificationComponent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NotificationsActions.showWorkspaceAddDocumentsNotificationComponent),
        tap(({ icon, title, duration, uniqueId }) => {
          let durationValue;

          if (!duration) {
            durationValue = constants.notificationHideDelay;
          } else {
            durationValue =
              duration === constants.notificationInfinityHideDelayKeyValue ? undefined : duration; // undefined = infinity
          }

          this.snackBar.openFromComponent(WorkspaceAddDocsSnackbarComponent, {
            data: {
              icon,
              title,
              uniqueId,
            },
            duration: durationValue,
            horizontalPosition: 'left',
            verticalPosition: 'bottom',
          });
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private readonly actions$: Actions,
    private readonly snackBar: MatSnackBar,
  ) {}
}
